<ul class="side-nav collapsed-side-nav tp-sidemenu" data-accordion-menu style="padding-top: 10px;">
  <li class="tp-sidebar-item" *ngIf="onboardStatus !== 'Done'">
    <a ripple class="collapsed" [ngClass]="{'selectedNav': pages['tpiq/onboard']}" (click)="showPage('tpiq/onboard')">
          <span class="side-nav-item badge-tooltip" [ngClass]="{'selected-nav-item': pages['tpiq/onboard']}">
            <img src="../../images/signup/shuttle.png"/>
            <span class="rightTooltiptext">Get Started</span>
          </span>
    </a>
  </li>
  <ng-template [ngIf]="onboardStatus === 'Done'">
    <li class="tp-sidebar-item">
      <a ripple class="collapsed" [ngClass]="{'selectedNav': pages['tpiq/dashboard']}" (click)="showPage('tpiq/dashboard')">
          <span class="side-nav-item badge-tooltip" [ngClass]="{'selected-nav-item': pages['tpiq/dashboard']}">
            <img src="../../images/tpiq-icons/dashboard_icon.png"/>
            <span class="rightTooltiptext">Dashboard</span>
          </span>
      </a>
    </li>
    <li class="tp-sidebar-item">
      <a ripple class="collapsed" [ngClass]="{'selectedNav': pages['tax-planning/clients']}" (click)="showPage('tax-planning/clients')">
        <span class="side-nav-item badge-tooltip" [ngClass]="{'selected-nav-item': pages['tax-planning/clients']}">
          <img src="../../images/tpiq-icons/SVG/people-icon.svg"/>
          <span class="rightTooltiptext">Clients</span>
        </span>
      </a>
    </li>
    <li class="tp-sidebar-item">
      <a ripple class="collapsed" [ngClass]="{'selectedNav': pages['tax-planning/taxStrategies']}" (click)="showPage('tax-planning/taxStrategies')">
        <span class="side-nav-item badge-tooltip" [ngClass]="{'selected-nav-item': pages['tax-planning/taxStrategies']}">
          <img src="../../images/tpiq-icons/SVG/strategies-icon.svg"/>
          <span class="rightTooltiptext">Tax Strategies</span>
        </span>
      </a>
    </li>
    <li class="tp-sidebar-item">
      <a ripple class="collapsed" [ngClass]="{'selectedNav': pages['tax-planning/templates']}" (click)="showPage('tax-planning/templates')">
        <span class="side-nav-item badge-tooltip" [ngClass]="{'selected-nav-item': pages['tax-planning/templates']}">
          <img src="../../images/tpiq-icons/folder.png"/>
          <span class="rightTooltiptext">Templates</span>
        </span>
      </a>
    </li>
    <li class="tp-sidebar-item">
      <a ripple class="collapsed" [ngClass]="{'selectedNav': pages['tax-planning/vendors']}" (click)="showPage('tax-planning/vendors')">
        <span class="side-nav-item badge-tooltip" [ngClass]="{'selected-nav-item': pages['tax-planning/vendors']}">
          <img src="../../images/tpiq-icons/team-network.png"/>
          <span class="rightTooltiptext">Vendors</span>
        </span>
      </a>
    </li>
    <li class="tp-sidebar-item" *ngIf="organizerAccess">
      <a ripple class="collapsed" [ngClass]="{'selectedNav': pages['tax-planning/organizer']}" (click)="showPage('tax-planning/organizer')">
          <span class="side-nav-item badge-tooltip" [ngClass]="{'selected-nav-item': pages['tax-planning/organizer']}">
            <img src="../../images/tpiq-icons/SVG/comment-black-icon.svg"/>
            <span class="rightTooltiptext">Questionnaire</span>
          </span>
      </a>
    </li>
    <li class="tp-sidebar-item" *ngIf="org === 'trialtaxplaniq' || (currentPlan && currentPlan.toLowerCase().includes('growth'))">
      <a ripple class="collapsed" [ngClass]="{'selectedNav': pages['tax-planning/growth-plan']}" (click)="showPage('tax-planning/growth-plan')">
          <span class="side-nav-item badge-tooltip" style="background-color: #DFCF6A !important;" [ngClass]="{'selected-nav-item': pages['tax-planning/growth-plan']}">
            <img src="../../images/tpiq-icons/SVG/firms-icon.svg"/>
            <span class="rightTooltiptext">Growth Plan</span>
          </span>
      </a>
    </li>
    <li class="tp-sidebar-item">
      <a ripple class="collapsed" [ngClass]="{'selectedNav': pages['tax-planning/todos']}" (click)="showPage('tax-planning/todos')">
        <span class="side-nav-item badge-tooltip" [ngClass]="{'selected-nav-item': pages['tax-planning/todos']}">
          <img src="../../images/tpiq-icons/SVG/to-dos-icon.svg"/>
          <span class="rightTooltiptext">To Do's</span>
        </span>
      </a>
    </li>
    <li class="tp-sidebar-item">
      <a ripple class="collapsed" [ngClass]="{'selectedNav': pages['tasks']}" (click)="showPage('tasks')">
        <span class="side-nav-item badge-tooltip" [ngClass]="{'selected-nav-item': pages['tasks']}">
          <img src="../../images/tpiq-icons/SVG/file-icon.svg"/>
          <span class="rightTooltiptext">Tasks</span>
        </span>
      </a>
    </li>
    <li class="tp-sidebar-item">
      <a ripple class="collapsed" [ngClass]="{'selectedNav': pages['tax-planning/events']}" (click)="showPage('tax-planning/events')">
        <span class="side-nav-item badge-tooltip" [ngClass]="{'selected-nav-item': pages['tax-planning/events']}">
          <img src="../../images/tpiq-icons/SVG/events-icon.svg"/>
          <span class="rightTooltiptext">Events</span>
        </span>
      </a>
    </li>
    <li class="tp-sidebar-item">
      <a ripple class="collapsed" [ngClass]="{'selectedNav': pages['tax-planning/taxlab']}" (click)="showPage('tax-planning/taxlab')">
        <span class="side-nav-item badge-tooltip" [ngClass]="{'selected-nav-item': pages['tax-planning/taxlab']}">
          <img src="../../images/tpiq-icons/icon2.png"/>
          <span class="rightTooltiptext">Tax Lab</span>
        </span>
      </a>
    </li>
    <li class="tp-sidebar-item" *ngIf="showAcademy">
      <a ripple class="collapsed" (click)="openLearningPortal()">
        <span class="side-nav-item badge-tooltip">
          <mat-icon aria-hidden="true">school</mat-icon>
          <span class="rightTooltiptext">TAXPLANIQ ACADEMY</span>
        </span>
      </a>
    </li>
    <li class="tp-sidebar-item">
      <a ripple class="collapsed" [ngClass]="{'selectedNav': pages['tax-planning/help']}" (click)="openTaxPlanningHelpPage()">
        <span class="side-nav-item badge-tooltip" [ngClass]="{'selected-nav-item': pages['tax-planning/help']}">
          <img src="../../images/tpiq-icons/SVG/help-icon.svg"/>
          <span class="rightTooltiptext">Help</span>
        </span>
      </a>
    </li>
  </ng-template>
</ul>
